<template>
  <div class="file-drop">
    <div
      class="file-drop__uploader"
      :class="{ 'has-drag': onDrag }"
      @dragenter.prevent="dragEnterHandler"
      @dragleave.prevent="dragLeaveHandler"
      @dragover.prevent
      @drop.prevent="dropHandler"
    >
      <div class="file-drop__selected" v-if="value">
        <i class="fa fa-file-o file-drop__selected__icon ie_i_file-drop"></i>
        <p class="file-drop__selected__name">
          選択したファイル : {{ value.name }}
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            @click.stop.prevent="cancelHandler"
          >
            キャンセル
          </button>
        </p>
      </div>

      <div class="file-drop__message" @click="openDialog" v-else>
        <i
          class="fa fa-cloud-upload file-drop__message__icon ie_i_file-drop"
        ></i>
        <p class="file-drop__message__text">
          ファイルをドラッグ&ドロップするか、クリックして選択してください
        </p>
      </div>

      <input type="file" ref="inputFile" @change="dropHandler" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["value"],

  data() {
    return {
      onDrag: false
    };
  },

  methods: {
    openDialog() {
      const inputFileElement = this.$el.querySelector('input[type="file"]');
      if (!inputFileElement) {
        return;
      }
      inputFileElement.click();
    },
    dragEnterHandler() {
      this.onDrag = true;
    },
    dragLeaveHandler() {
      this.onDrag = false;
    },
    dropHandler(e) {
      this.onDrag = false;

      const fileList = e.target.files ? e.target.files : e.dataTransfer.files;

      if (fileList.length > 1) {
        window.alert("アップロードするファイルは1つずつ選択してください");
        return;
      } else if (fileList.length === 0) {
        return;
      }

      this.$emit("input", fileList[0]);
      this.$refs.inputFile.value = "";
    },
    cancelHandler() {
      this.$emit("input", null);
    }
  }
};
</script>

<style lang="scss" scoped>
.file-drop {
  border: 2px solid #ccc;

  &__uploader {
    position: relative;
    overflow: hidden;
    background: #dedddd;

    &.has-drag {
      background: #fff;
    }

    input[type="file"] {
      position: absolute;
      left: 100%;
      top: 100%;
    }
  }

  &__selected {
    min-height: 230px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #fff;

    &__icon {
      font-size: 4.4em;
    }

    &__name {
      margin: 1em 0 0;

      button {
        margin-left: 0.5em;
      }
    }
  }

  &__message {
    cursor: pointer;
    min-height: 230px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &__icon {
      font-size: 4.4em;
    }

    &__text {
      margin: 1em 0 0;
      pointer-events: none;
    }
  }
}
@media all and (-ms-high-contrast: none) {
  .file-drop__message {
    height: 230px;
  }
}
</style>
